import React from "react";
import { Edit, Create, SelectInput, SimpleForm, TextInput } from "react-admin";
import { ColorInput } from "react-admin-color-input";

const statePublishedChoices = [
  { id: "DRAFT", name: "DRAFT" },
  { id: "PUBLIC", name: "PUBLIC" },
  { id: "INTERNAL", name: "INTERNAL" },
];

function NoticeForm(props) {
  return (
    <SimpleForm {...props}>
      <TextInput source="id" disabled fullWidth />
      <TextInput source="title" fullWidth />
      <TextInput source="text" multiline lines={6} fullWidth />
      <ColorInput source="gradientFrom" fullWidth />
      <ColorInput source="gradientTo" fullWidth />
      <SelectInput
        choices={[
          { id: null, name: "disabled" },
          { id: "occurrence", name: "occurrence" },
          { id: "page", name: "page" },
          { id: "profile", name: "profile" },
          { id: "collage", name: "collage" },
          { id: "url", name: "url" },
          { id: "timeline", name: "timeline" },
          { id: "profileList", name: "profileList" },
          { id: "notificationCenter", name: "notificationCenter" },
          { id: "followedCalendar", name: "followedCalendar" },
          { id: "internal", name: "internal" },
          { id: "categories", name: "categories" },
        ]}
        label="Link Type"
        source="link_resourceType"
        fullWidth
      />
      <TextInput
        label="Link ID / URL / Section"
        source="link_resourceId"
        fullWidth
      />
      <SelectInput
        choices={statePublishedChoices}
        source="statePublished"
        fullWidth
      />
    </SimpleForm>
  );
}

function NoticeEdit(props) {
  return (
    <Edit {...props}>
      <NoticeForm />
    </Edit>
  );
}

function NoticeCreate(props) {
  return (
    <Create {...props}>
      <NoticeForm />
    </Create>
  );
}

export { NoticeEdit, NoticeCreate };
